<template>
    <d-contract-edit
        v-model      = "edit"
        title        = "Wartung"
        :type-id     = "typeId"
        :contract-id = "contractId"
        :company-id  = "companyId"
        @initialized = "onInitialized"
        @saved       = "onSaved"
    >
        <template v-slot:terms>
            <c-column-header
                class  = "primary mt-0"
                :label = "$t('contract.terms') "
            />

            <div class="lm-border pa-3 pt-0 mt-1">
                <c-contract-mnt-terms
                    :contract   = "contract"
                    :readonly   = "false"
                    :unit-mode  = "false"
                    :show-title = "false"
                />
            </div>
        </template>
        <template v-slot:post>
            <v-row class="no-frame pt-0">
                <f-enum-autocomplete
                    v-if    = "contract"
                    v-model = "contract.service"
                    label   = "Service"
                    module  = "msd"
                    type    = "servicecompanies"
                    clearable
                />
            </v-row>
            <v-row class="no-frame">
                <f-enum-autocomplete
                    v-if    = "contract"
                    v-model = "contract.prmRole"
                    label   = "Verwalter"
                    module  = "msd"
                    type    = "servicecompanies"
                    clearable
                />
            </v-row>
        </template>
    </d-contract-edit>
</template>

<script>

import Core              from "@/modules/core/service/Core";
import Contract            from "@/modules/msd/company/contract/service/Contract";
import CContractMntTerms from "@/modules/msd/company/contract/components/controls/mnt/CContractMntTerms";
import DContractEdit     from "@/modules/msd/company/contract/components/controls/DContractEdit";
import CColumnHeader     from "@/modules/core/components/utils/CColumnHeader";
import FEnumAutocomplete from "@/modules/core/components/utils/FEnumAutocomplete.vue";

export default {
    name: "DContractMntEdit",

    components: {
        FEnumAutocomplete,
        CColumnHeader,
        DContractEdit,
        CContractMntTerms,
    },

    props: {
        value: {

        },

        contractId: {
            required: false,
            type    : Number,
            default : function () {
                return null
            }
        },

        companyId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },
    },

    data: () => ({
        edit    : false,
        contract: null,
    }),

    watch: {
        value () {
            this.edit = this.value;
        },

        edit () {
            if (!this.edit)
                this.$emit("input", this.edit);
        }
    },

    computed: {
        typeId () {
            return Contract.enums.types.mnt;
        }
    },

    methods: {
        onInitialized (contract) {
            this.contract = contract;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        },

    }
}
</script>

<style scoped>

.headline {
    font-size: 16px!important;
    height: 35px;
    padding-top: 3px!important;
}

</style>